/**
 *
 * Component.prepare() 拡張
 *
 * コンポーネント内ガード (beforeRouteEnter, beforeRouteUpdate) より便利に
 * 非同期データ取得方法を提供する。
 *
 */
import store from '@/store'

/**
  * ルートオブジェクトのラップクラス
  *
  * Component.prepare() で別のルートに移動したいとき、
  * return new Route({name: ...}) とする
  */
export class Route {
  constructor (route) {
    this.route = route
  }
}

/**
  * Component.prepare() を有効にする RouteConfig 定義を生成する
  *
  * @param {Component} compo 使用するコンポーネント
  * @returns {RouteConfig} RouteConfig に付加する定義を返す
  */
export default function component (compo) {
  const component = async function () {
    // 遅延ローディングを実行する
    if (typeof compo === 'function') {
      compo = (await compo()).default
    }

    // compo.prepare() があるか
    const usePrepare = (typeof compo.prepare === 'function')

    // compo.prepare() がなければ、通常の設定を返す
    if (!usePrepare) {
      return compo
    }

    //
    // beforeRouteEnter, beforeRouteUpdate で呼ばれるハンドラを定義
    //
    const handler = async function (to, from, next) {
      // compo.prepare を呼び出す
      let result = compo.prepare(to, from, store)

      // Promise が返されたら、終了を待つ
      if (result instanceof Promise) {
        result = await result.catch(e => e)
      }

      if (result instanceof Error) {
        // router.onError() へ
        next(result)
      } else if (result instanceof Route) {
        // 指定のルートへ
        next(result.route)
      } else {
        // to.meta.props を介してデータをコンポーネントに受け渡す
        to.meta.props = result
        next()
      }
    }

    return {
      ...compo,
      beforeRouteEnter: handler,
      beforeRouteUpdate: handler
    }
  }

  return {
    component,
    props: route => route.meta.props
  }
}
